import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import getUserLanguage from '@/config/language';
import { useUser } from '@/contexts/UserContext';
import AccompaniedInspectionIcon from '@/svg-icons/AccompaniedInspection';
import Whatsapp from '@/svg-icons/whatsapp';

const AccompaniedInspectionSection = ({ data }) => {
  const me = useUser();

  const openWhatsapp = () => {
    const country = me?.profile?.country || 'BR';
    const countryDialCodes = { BR: '55', PT: '351', CO: '57', MX: '52', UY: '598', PY: '595', ES: '34' };
    const countryCode = countryDialCodes[country] || '55';
    const phone = data.companionContact.replace(/\D/g, '');
    window.open(`https://wa.me/+${countryCode}${phone}`, '_blank');
  };

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <AccompaniedInspectionIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0 align-middle" />
        <FormattedMessage id="accompaniedInspection" />
      </div>

      <div className="grid grid-cols-12 gap-y-4 text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="col-span-8 flex flex-col" data-cy="order-details-is-accompanied">
          <div className="font-bold">
            <FormattedMessage id="isAccompanied" />
          </div>
          {data.isAccompanied ? <FormattedMessage id="Yes" /> : <FormattedMessage id="No" />}
        </div>

        {data.scheduleDate ? (
          <div className="col-span-4 flex flex-col" data-cy="order-details-schedule-date">
            <div className="font-bold">
              <FormattedMessage id="scheduleDateView" />
            </div>
            {data.scheduleDate}
          </div>
        ) : null}

        {data.companionName ? (
          <div className="col-span-8 flex flex-col" data-cy="order-details-companion-name">
            <div className="font-bold">
              <FormattedMessage id="companionName" />
            </div>
            {data.companionName}
          </div>
        ) : null}

        {data.companionContact ? (
          <div className="col-span-4 flex flex-col" data-cy="order-details-companion-contact">
            <div className="font-bold">
              <FormattedMessage id="companionContact" />
            </div>
            {data.companionContact}
            <div 
              className="text-[#0485BE] cursor-pointer flex items-center mt-1" 
              onClick={openWhatsapp}
            >
              <Whatsapp style={{ verticalAlign: 'middle', marginRight: '5px', fontSize: '18px', width: '18px', height: '18px' }} />
              Abrir no WhatsApp Web
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

AccompaniedInspectionSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AccompaniedInspectionSection;
